import ReCaptcha, { ReCAPTCHAProps } from 'react-google-recaptcha';
import { useEffect, useState } from 'react';
const GoogleCaptcha = (props: ReCAPTCHAProps) => {
  const [renderCaptcha, setRenderCaptcha] = useState(true);

  useEffect(() => {
    // Notes: currently google captcha doesn't support i18n, so I have to re-render Captcha which has language as parameter
    setRenderCaptcha(false);
    setTimeout(() => setRenderCaptcha(true));
  }, [props.hl]);
  return (
    <>
      {renderCaptcha && (
        <ReCaptcha
          hl={props.hl === 'zh' ? 'zh-TW' : props.hl}
          sitekey={props.sitekey}
          onChange={props.onChange}
          onError={props.onError}
          onExpired={props.onExpired}
        />
      )}
    </>
  );
};

export default GoogleCaptcha;
